import styled from 'styled-components';
import {
  COLOR,
  FONT_SIZE,
  RADIUS,
  SPACING,
} from '../../../../../constants/theme';

export const CalendarWrapper = styled.div`
  .ant-picker-calendar {
    background: transparent;
  }

  .ant-picker-content th {
    padding: 0 0 2px;
    font-size: ${FONT_SIZE.stepLabel};
    font-weight: 500;
    text-align: center;
    color: ${COLOR.textSecondary};
  }

  .ant-picker-cell {
    padding: 2px;
  }

  .ant-picker-cell::before,
  .ant-picker-calendar-date-today::before {
    display: none;
  }
`;

export const MonthNav = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACING.md};
  padding: 0 0 ${SPACING.md};
`;

export const MonthTitle = styled.span`
  font-size: ${FONT_SIZE.cardTitle};
  font-weight: 700;
  color: ${COLOR.navy};
`;

export const MonthNavButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 40px;
  height: 40px;
  border: 1px solid ${COLOR.border};
  border-radius: ${RADIUS.md};
  background: ${COLOR.surface};
  color: ${COLOR.primary};
  font-size: ${FONT_SIZE.value};
  cursor: pointer;

  &:hover:not(:disabled) {
    border-color: ${COLOR.primary};
    background: ${COLOR.primaryLight};
  }

  &:disabled {
    background: ${COLOR.mutedBackground};
    color: ${COLOR.textMuted};
    cursor: not-allowed;
  }
`;

export const DayCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  border: 1px solid
    ${({ $isAvailable, $isSelected }) => {
      if ($isSelected) return COLOR.primary;
      if ($isAvailable) return COLOR.primaryBorder;
      return 'transparent';
    }};
  border-radius: ${RADIUS.md};
  background: ${({ $isAvailable, $isSelected }) => {
    if ($isSelected) return COLOR.primary;
    if ($isAvailable) return COLOR.primaryLight;
    return COLOR.mutedBackground;
  }};
  color: ${({ $isAvailable, $isSelected }) => {
    if ($isSelected) return COLOR.surface;
    if ($isAvailable) return COLOR.primary;
    return COLOR.textMuted;
  }};
  font-size: ${FONT_SIZE.body};
  font-weight: ${({ $isAvailable }) => ($isAvailable ? 700 : 400)};
  font-variant-numeric: tabular-nums;
  cursor: ${({ $isAvailable }) => ($isAvailable ? 'pointer' : 'default')};
`;

export const CalendarLegend = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: ${SPACING.md};
  font-size: ${FONT_SIZE.hint};
  color: ${COLOR.textSecondary};
`;

export const LegendItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

export const LegendSwatch = styled.i`
  display: inline-block;
  width: 10px;
  height: 10px;
  border: 1px solid ${({ $borderColor }) => $borderColor || 'transparent'};
  border-radius: 3px;
  background: ${({ $background }) => $background};
`;
